import Button from '../Form/FormFields/ButtonField';
import CommonServices from '../../utils/customHook/CommonServices';
import { useSelector } from 'react-redux';

function ApplyAndReset({ renderAbleId, stateAndApiData, props }) {
  const { handleReset, handleApply } = CommonServices(props);
  const selecterData = useSelector((state: RootState) => state.district);

      // selectorData?.chart_list_data?.main_filterable_chart_ids,
      //   selectorData?.chart_list_data?.secondary_filterable_chart_ids,

  return (
    <div className="">
      <Button
        className={`btn ${
          selecterData?.disabled ? "disabled-btn mr-2 " : "apply-btn mr-2"
        } `}
        onClick={() => handleApply(renderAbleId)}
        name="Apply"
        disabled={selecterData?.disabled}
      />
      <Button
        className={`btn ${
          selecterData?.disabled ? "disabled-btn" : "reset-btn"
        } `}
        onClick={() => handleReset(stateAndApiData, renderAbleId)}
        name="Reset"
        disabled={selecterData?.disabled}
      />
    </div>
  );
}

export default ApplyAndReset